enum TagsEnum {
	BUSINESS = '#business',
	VWSF_DK = '#vwsfdk',
	BROKER = '#broker',
}

export default TagsEnum;
